/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ModalBody, ModalFooter, ModalHeader, ModalNext, Icon, useModal, Loader } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TranslatorContext, useTranslator } from '@jutro/locale';
import {
    JobService,
    SubmissionService,
    UserService,
} from 'gw-capability-gateway';

import metadata from './ConstructionDetailsAccordion.metadata.json5';
import styles from './ConstructionDetailsAccordion.module.scss'


import { Button, CheckboxField, Radio, RadioField } from '@jutro/legacy/components';


const ConstructionDetailsAccordion = props => {
    const {
        policyDetailsData, lobData_TWIA, policyTransactionDetails, producerOfServiceValue,
        producerOfRecordValue, isDwelling,
        isTenant,
        isMH,
        isApartmentOrCondo
    } = props;

    const translator = useTranslator();

    // DE17811
    const buildingCodeClass_TWIAValue = () =>{
            const buildingCodeClass_TWIACode = _.get(lobData_TWIA,'homeOwners.dwellingDTO.constructionDetails.buildingCodeClass_TWIA')
            const buildingCodeClass_TWIA = translator({
                id: `typekey.BuildingCodeClass_TWIA.${buildingCodeClass_TWIACode}`,
                defaultMessage: buildingCodeClass_TWIACode,
            });
            return buildingCodeClass_TWIA
        }
    
        const buildingCode_TWIAValue = () =>{
            const buildingCode_TWIACode = _.get(lobData_TWIA,'homeOwners.dwellingDTO.constructionDetails.buildingCode_TWIA')
            const buildingCode_TWIA = translator({
                id: `typekey.BuildingCode_TWIA.${buildingCode_TWIACode}`,
                defaultMessage: buildingCode_TWIACode,
            });
            return buildingCode_TWIA
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        certificateOfCompliance: {
            value: _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.hasWPI8CertOfCompIssued_TWIA') ? 'Yes' : 'No'
        },
        buildingCodeClass: {
            visible: isTenant || isDwelling,
            value: buildingCodeClass_TWIAValue()
        },
        buildingCode: {
            visible: isTenant || isDwelling,
            value: buildingCode_TWIAValue()
        },
        oriConstDate: {
            visible: !isMH
        },
        modelYear: {
            visible: isMH
        },
        squareFootage: {
            visible: !isMH
        },
        dwellingCondition: {
            visible: isMH || isDwelling
        },
        foundationType: {
            visible: !isMH && !isTenant && !isApartmentOrCondo
        },
        noOfStories: {
            visible: isDwelling
        },
        roofType: {
            visible: !isMH && !isTenant && !isApartmentOrCondo
        },
        constructionType: {
            visible: !isMH
        }
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        }
    };




    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={lobData_TWIA}
            // onModelChange={updateWizardData}
            // onValueChange={writeValue}
            // showErrors={showErrors}
            // onValidationChange={setComponentValidation}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


ConstructionDetailsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    //authHeader: PropTypes.shape({}).isRequired,
};
export default ConstructionDetailsAccordion;
